export default {"src":"/_next/static/media/email.12c57658.svg","height":24,"width":24};